// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"c1db29b0","232":"9692ee3d","344":"f70ff4a7","438":"e6c03246","453":"67801c4f","466":"ba0ffaa3","468":"58d13c2d","579":"07ddbc67","659":"fe6f1fc3","688":"16865366","738":"0ba2677e","759":"d13a18bb","773":"d43525a9","812":"fcd952bd","916":"1df971a3","926":"ec29bf10"}[chunkId] + ".chunk.js";
};